<template>
  <v-layout
    row
    justify-center
  >
    <v-dialog
      v-if="responseMessage.modal"
      :value.sync="responseMessage.show"
      persistent
      :fullscreen="iOS && inIframe"
      max-width="768"
    >
      <v-card>
        <v-card-title
          class="title-name white--text"
          :style="`background: ${colors[responseMessage.type]}`"
        >{{ responseMessage.title }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text v-html="responseMessage.text"></v-card-text>
        <v-layout
          row
          justify-center
          wrap
        >
          <template v-if="responseMessage.buttons">
            <v-btn
              v-for="btn in responseMessage.buttons"
              :key="btn.text"
              :color="colors[btn.color]"
              flat
              @click.native="clickBtn2(btn)"
            >{{ btn.text }}</v-btn>
          </template>
          <v-btn
            v-else-if="responseMessage.btn"
            dark
            flat
            @click.native="clickBtn(responseMessage.btn)"
          >{{ responseMessage.btn.text }}</v-btn>
          <template v-else-if="responseMessage.btn3">
            <v-btn
              dark
              :color="responseMessage.type"
              flat
              @click.native="close"
            >{{ $t('cancel') }}</v-btn>
            <v-btn
              dark
              :color="responseMessage.type"
              flat
              @click.native="clickBtn3(responseMessage.btn3)"
            >{{ responseMessage.btn3.text }}</v-btn>
          </template>
          <v-btn
            v-else
            :color="responseMessage.type"
            flat="flat"
            @click.native="close"
          >{{ $t('ok') }}</v-btn>
        </v-layout>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-else
      :top="!displayBottom"
      :bottom="displayBottom"
      :right="displayBottom"
      v-model="responseMessage.show"
      :color="colors[responseMessage.type]"
      :timeout="responseMessage.timeout"
      :style="snackBarStyle"
    >
      {{ responseMessage.text }}
      <v-btn
        v-if="responseMessage.btn"
        dark
        flat
        @click.native="clickBtn(responseMessage.btn)"
      >{{ responseMessage.btn.text }}</v-btn>
      <v-btn
        v-else-if="!responseMessage.noBtn"
        dark
        flat
        @click.native="close"
      ><v-icon small>close</v-icon></v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import { isNavigationFailure } from 'vue-router/src/util/errors'

export default {
  name: 'feedback-message',
  computed: {
    ...mapGetters('config', [
      'theme', 'iOS', 'inIframe', 'colors'
    ]),
    ...mapGetters('message', [
      'responseMessage'
    ]),
    displayBottom () {
      return this.$mq === 'sm' || this.$mq === 'md' || this.$mq === 'lg' || this.$mq === 'xl'
    },
    snackBarStyle () {
      if (this.$mq === 'lg' || this.$mq === 'xl') {
        return {
          marginRight: '300px'
        }
      }
    }
  },
  methods: {
    getMsgColor (type) {
      const color = 'msg_' + type + '_color'
      return this.theme[color]
    },
    close () {
      this.$store.dispatch('clearMessage')
    },
    clickBtn2 (btn) {
      this.close()
      if (btn.action) {
        if (btn.param !== null) {
          this.$store.dispatch(btn.action, btn.param)
        } else {
          this.$store.dispatch(btn.action)
        }
        if (btn.path) {
          if (this.$route.name !== 'menu' && this.$route.name !== 'welcome') this.$bus.$emit('showFullLoading', true)
          this.$router.push({ name: btn.path }).catch(failure => {
            if (isNavigationFailure(failure)) {
              // show a small notification to the user
            }
          })
          this.$bus.$emit('showFullLoading', false)
        }
      } else if (btn.path) {
        this.$router.push({ name: btn.path }).catch(failure => {
          if (isNavigationFailure(failure)) {
            // show a small notification to the user
          }
        })
      }
    },
    clickBtn (btn) {
      this.close()
      if (btn.action) {
        if (btn.param !== null) {
          this.$store.dispatch(btn.action, btn.param)
        } else {
          this.$store.dispatch(btn.action)
        }
      } else if (btn.path) {
        this.$router.push({ name: btn.path }).catch(failure => {
          if (isNavigationFailure(failure)) {
            // show a small notification to the user
          }
        })
      }
    },
    clickBtn3 (btn) {
      this.close()
      if (btn.param) {
        this.$bus.$emit(btn.function, btn.param)
      } else {
        this.$bus.$emit(btn.function)
      }
    }
  }
}
</script>

<style scoped>
.snack__content {
  max-width: 100vw;
  min-width: 100vw;
}
.title-name {
  font-size: 17px;
  padding-top: 10px;
  padding-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/FeedbackMessage.vue